import { createContext, useContext, useEffect, useState } from 'react';
import { fetchUser, login as apiLogin, logout as apiLogout } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUser()
      .then((u) => setUser(u))
      .catch(() => setUser(null))
      .finally(() => {
        setLoading(false);
        // App pronta (utente noto o meno) → sfuma lo splash screen del blade.
        try { window.__rvlHideSplash && window.__rvlHideSplash(); } catch { /* noop */ }
      });
  }, []);

  async function login(email, password, remember = false) {
    const u = await apiLogin(email, password, remember);
    setUser(u);
    return u;
  }

  async function logout() {
    try {
      await apiLogout();
    } finally {
      setUser(null);
    }
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
